<template>
  <w-icon-wrapper
    :height='18'
    :width='18'
    icon-name='work-checkbox-unselect-icon'
    view-box='0 0 18 18'
  >
    <rect
      id="Checkbox_Unselected"
      width="18"
      height="18"
      rx="2"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckboxUnselect' };
</script>
